module.exports = __webpack_public_path__ + "assets/img/16_1743_big.7b5ed9a1.jpg";